import _ from 'underscore';
import { DeterministicView } from '@bingads-webui/deterministic-view';

/**
 * @typedef {Object} DeterministicWrapperViewState
 * @property describe your properties in the state here
 */

export class DeterministicWrapperView extends DeterministicView {
  initialize(options) {
    this.view = this.viewFactory(options);
    this.listenTo(this.view, 'all', this.trigger);
    this.rendered = false;
  }

  viewFactory(/* options */) {
    throw new Error('Unimplemented view factory');
  }

  renderTrunk() {
    if (!this.rendered) {
      this.rendered = true;
      this.view.render();
    }

    this.$el.append(this.view.$el);
    return this;
  }

  remove() {
    this.view.remove();
    return super.remove();
  }

  /**
   * Set state of the view.
   * Since this is a wrapper view, the state should be propagated to the wrapped view.
   * @param {Object} state - The new state
   * @returns {DeterministicWrapperView} - The view itself
   */
  setState(state) {
    super.setState(state);
    if (this.view && _.isFunction(this.view.setState)) {
      this.view.setState(state);
    }
    return this;
  }

  /**
   * Class name of the root element
   * @type {string}
   * @override
   */
  get className() { return 'deterministic-wrapper-view'; }
}
